import {
  STAFF,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case STAFF.handlers.get:
      return {
        ...state,
        handling: true,
      };
    case STAFF.update:
      return {
        ...state,
        data: action.data,
        handling: false,
      };
    default:
      return state;
  }
}
